import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { FlexModule } from '@ngbracket/ngx-layout';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '@shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { NumberInputModule } from '@sharedComponents/form/number-input/number-input.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateTimeInputModule } from '@sharedComponents/form/date-time-input/date-time-input.module';
import { U2bConfirmDialogComponent } from './confirm-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OrderModule } from 'ngx-order-pipe';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [
        U2bConfirmDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        DragDropModule,
        MatToolbarModule,
        MatIconModule,
        FlexModule,
        FuseSharedModule,
        MatFormFieldModule,
        SharedModule,
        MatInputModule,
        NumberInputModule,
        MatCheckboxModule,
        DateTimeInputModule,
        MatAutocompleteModule,
        OrderModule,
        TranslationModule
    ],
})
export class U2bConfirmDialogModule {
}
